import React from 'react';
import { HQContent } from './HQDashboard';

// The Dashboard is now the HQ operations view (region rollup) for everyone in the IT app.
// Campus IT sees only their assigned campuses; Admin / IT Head see all.
export default function Dashboard({ go }) {
  return <HQContent go={go} />;
}
